import { Component, OnInit } from '@angular/core';
import {
  DashboardKpiService,
  SalesSummaryEntity,
  Timespan,
  LastVsThisYearSalesAmountSummaryCardComponent
} from 'gung-dashboard';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-last-vs-this-year-sales-amount-summary-card',
    templateUrl: './colmec-last-vs-this-year-sales-amount-summary-card.component.html',
    styleUrls: ['./colmec-last-vs-this-year-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class ColmecLastVsThisYearSalesAmountSummaryCardComponent
  extends LastVsThisYearSalesAmountSummaryCardComponent
  implements OnInit
{
  constructor(protected dashboardKpiService: DashboardKpiService) {
    super(dashboardKpiService);
  }

  ngOnInit() {
    const thisYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Year);
    const lastYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastYear);

    forkJoin({
      salesSummaryGroupsThisYear: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisYearSpan.fromDate)
        .pipe(first()),
      salesSummaryGroupsLastYear: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastYearSpan.fromDate, lastYearSpan.toDate)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisYear, salesSummaryGroupsLastYear }) => {
      this.salesAmountThisYear = salesSummaryGroupsThisYear.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.salesAmountLastYear = salesSummaryGroupsLastYear.reduce((acc, curr) => acc + curr.totalQuantity, 0);
      this.loaded = true;
    });
  }
}
